import script from "./EventTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventTip.vue?vue&type=script&setup=true&lang=ts"

import "./EventTip.vue?vue&type=style&index=0&id=39dd85f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39dd85f8"]])

export default __exports__